import React from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'
import { push } from 'react-router-redux'

import * as actions from 'Global/Stores/group'
import * as selectors from './selectors'

export default function(WrappedComponent) {
  const Enhancer = props => <WrappedComponent {...props} />

  const mapStateToProps = (state, ownProps) => ({
    group: selectors.group(state),
    groupDone: selectors.groupDone(state),
    groupError: selectors.groupError(state),
    groupPending: selectors.groupPending(state),
    groupWasDeleted: selectors.groupWasDeleted(state),
    user: selectors.user(state),
  })

  const mapDispatchToProps = (dispatch, ownProps) => ({
    deleteGroup: id => dispatch(actions.groupDelete(id)),
    getGroup: id => dispatch(actions.groupGet(id)),
    redirectToGroups: () => dispatch(push(`/groups`)),
    resetGroup: () => dispatch(actions.groupReset()),
    setName: (id, name) => dispatch(actions.groupSetName(id, name)),
    setPermissions: (id, permissions) => dispatch(actions.groupSetPermissions(id, permissions)),
  })

  Enhancer.displayName = 'GroupDetailModuleEnhancer'

  Enhancer.propTypes = {
    deleteGroup: PropTypes.func.isRequired,
    getGroup: PropTypes.func.isRequired,
    group: PropTypes.object.isRequired,
    groupDone: PropTypes.bool.isRequired,
    groupError: PropTypes.bool.isRequired,
    groupPending: PropTypes.bool.isRequired,
    groupWasDeleted: PropTypes.bool.isRequired,
    redirectToGroups: PropTypes.func.isRequired,
    resetGroup: PropTypes.func.isRequired,
    router: PropTypes.object.isRequired,
    setName: PropTypes.func.isRequired,
    setPermissions: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
  }

  return connect(
    mapStateToProps,
    mapDispatchToProps,
  )(Enhancer)
}
